import { CustomPlpActionsUnion, CustomPlpActionTypes } from './custom-plp.actions';
import { CustomPlpInitialState } from './custom-plp.state';

export function customPlpReducer(state = CustomPlpInitialState, action: CustomPlpActionsUnion) {
  switch (action.type) {
    case CustomPlpActionTypes.LOAD_CUSTOMPLP_CONFIG_CONTENT:
      return { ...state };
    case CustomPlpActionTypes.LOAD_CUSTOMPLP_CONFIG_CONTENT_SUCCESS:
      const { response } = action.payload;

      return {
        ...state, ...response
      };
    case CustomPlpActionTypes.LOAD_CUSTOMPLP_CONFIG_CONTENT_FAILURE:
      return {
        ...state,
        filters: {
          categoryIds: [],
          hasPromotion: false,
          promoTag: ''
        },
        itemIds: [],
        sortedIds: [],
        slug: '',
        header: '',
        title: '',
        description: '',
        image: {},
        is_published: false
      };
    default:
      return state;
  }
}
